import React from 'react';
import { PropTypes } from 'prop-types';
import InputMask from 'react-input-mask';

const StrictInput = ({
  input,
  mask,
  className,
  placeholder,
  style
}) => (
  <InputMask
    { ...input }
    mask={ mask }
    maskChar=" "
    className={ `${ className }` }
    placeholder={ `${ placeholder }` }
    style={ style }
  />
);

StrictInput.propTypes = {
  input: PropTypes.shape({}).isRequired,
  mask: PropTypes.string.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  style: PropTypes.shape({})
};

StrictInput.defaultProps = {
  className: '',
  placeholder: '',
  style: null
};

// eslint-disable-next-line import/prefer-default-export
export { StrictInput };
